module.exports = __webpack_public_path__ + "img/invest-big-data-crop.ae56afc8.jpg";